import styled from "styled-components";

export const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 100%;
  min-height: 100%;
  flex: 1;
  justify-content: center;
  align-items: center;
`;